/* eslint-disable @typescript-eslint/no-explicit-any */
import {CheckCircle} from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
} from '@mui/material';
import {useNavigate} from 'react-router-dom';

export const CertChecker = ({open, onClose, requiredCerts}: any) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/documents/certifications');
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle textAlign="center">Required Certifications</DialogTitle>
      <DialogContent>
        <Box sx={{textAlign: 'center', mb: 2, color: 'info.main'}}>
          Please ensure that you have provided all the required certifications
          before applying for this position
        </Box>
        <Box sx={{maxHeight: '280px', overflowY: 'auto'}}>
          <Grid
            container
            spacing={2}
            sx={{width: '100%', mt: 0, ml: 0, pb: 0.5}}
          >
            {requiredCerts &&
              requiredCerts.map((cert: any) => (
                <Grid
                  container
                  key={cert.id}
                  spacing={2}
                  alignItems="center"
                  sx={{margin: '0px', width: '100%'}}
                >
                  <Grid item xs={8}>
                    <Box
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        wordWrap: 'break-word',
                      }}
                    >
                      {cert?.name}
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{display: 'flex', justifyContent: 'center'}}
                  >
                    {cert?.status ? (
                      <CheckCircle sx={{color: 'success.main'}} />
                    ) : (
                      <Button
                        variant="outlined"
                        onClick={() => handleRedirect()}
                        sx={{width: '50px'}}
                      >
                        Upload
                      </Button>
                    )}
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions style={{justifyContent: 'center'}}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
